<div class="top-page sidebar-collapse">
  <app-l-header></app-l-header>
  <!-- End Navbar -->
  <!--<div class="wrapper wrapper-full-page">
    <div class="page-header login-page header-filter" filter-color="black" style="background-image:
    url('../../../assets/images/bespoke.jpg'); background-size: cover; background-position: top center;">
      &lt;!&ndash;   you can change the color of the filter page using: data-color="blue | purple | green | orange | red | rose " &ndash;&gt;
      <div class="container">
        <div class="col-lg-4 col-md-6 col-sm-6 ml-auto mr-auto">
            <div class="card card-login card-hidden">
              <div class="card-header card-header-warning text-center">
                <h4 class="card-title">LOGIN</h4>
                <div class="social-line">
                 Login to your account
                </div>
              </div>
              <form novalidate  #loginForm="ngForm" (ngSubmit)="loginProcess()">
                <div class="card-body">
                  &lt;!&ndash;<span class="font-weight-bold red" >{{ errorMessage | titlecase }}</span>&ndash;&gt;
                  <div class="bmd-form-group">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="material-icons">email</i>
                        </span>
                      </div>
                      <input type="email" class="form-control" placeholder="Email"
                             #email="ngModel" minlength="4" id="email"
                             [(ngModel)]="credentials.email" [ngModelOptions]="{standalone: true}" required>
                    </div>
                  </div>
                <div class="bmd-form-group">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="material-icons">lock_outline</i>
                        </span>
                      </div>
                      <input type="password" class="form-control " placeholder="Password" #password="ngModel" minlength="8" id="password"
                             [(ngModel)]="credentials.password" [ngModelOptions]="{standalone: true}" required>
                    </div>
                  </div>
              </div>
              <div class="card-footer justify-content-center">
                <button type="submit" class="btn btn-warning btn-lg" [disabled]="password.errors || email.errors || loading">
                  <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>LOGIN TO ACCOUNT</button>
              </div>

                <div class="text-center" style="font-size: 13px;">
                  <p class="px-2"><a href="javascript:void(0)" [routerLink]="['/forgot-password']" class="text-rose">Forgot password?</a></p>
                </div>
              </form>
            </div>
        </div>
      </div>
    </div>
  </div>-->

  <div class="wrapper wrapper-full-page">
    <div class="page-header login-page header-filter" filter-color="black" style="background-image:
  url('../../../assets/img/collegedreams.jpg'); background-size: cover; background-position: top center;">
      <!--   you can change the color of the filter page using: data-color="blue | purple | green | orange | red | rose " -->
      <div class="container end">
        <div class="row login-cards">
          <div class="col">
            <div *ngIf="step == 1" class="d-flex align-items-start flex-column left-writeup" style="height: 200px;">
              <div class="p-2 pg1 text-center">
                Enjoy our all-in one school <br>
                software for FREE!!
              </div>
              <div class="p-2 pg2 text-center">
                Fill the form to Sign up
              </div>
            </div>

            <div *ngIf="step == 2" class="d-flex align-items-start flex-column left-writeup" style="height: 200px;">
              <div class="p-2 pg3 text-center">
                You’re almost there
              </div>
              <div class="p-2 pg2 text-center">
                Fill the form to Sign up
              </div>
            </div>

            <div *ngIf="step == 3" class="d-flex align-items-start flex-column left-writeup" style="height: 200px;">
              <div class="p-2 pg3 text-center">
                Finally, you’re here!!
              </div>
              <div class="p-2 pg2 text-center">
                Fill the form to Sign up
              </div>
            </div>

          </div>
          <div class="col-lg-5 col-md-6 col-sm-6 ml-auto mr-auto">
            <div class="card card-login">
              <div class="card-header text-center">
                <h4 class="card-title">Sign Up</h4>
              </div>
              <form novalidate  [formGroup]="signup" (ngSubmit)="submit()">
                <div *ngIf="step == 1" formGroupName="Form1Details" class="card-body">
                  <!--SchoolName-->
                  <div class="bmd-form-group pb-3">
                    <div class="input-group">
                      <div class="input-group-prepend">
                      </div>
                      <input type="text" class="form-control"
                             placeholder="School Name"
                             formControlName="schoolName"
                             id="SchoolName" required
                             autocomplete="false">
                      <!--<span class="text-danger errorMSG"
                            *ngIf="submitted && Form1Details.SchoolName.errors?.required">
                        Please Enter School Name
                      </span>-->
                    </div>
                  </div>
                  <!--schoolAbbreviation-->
                  <div class="bmd-form-group pb-3">
                    <div class="input-group">
                      <div class="input-group-prepend">
                      </div>
                      <input type="text" class="form-control"
                             placeholder="School Abbreviation"
                             formControlName="schoolAbbreviation"
                             maxlength="5"
                             id="SchoolAbbreviation" required
                             autocomplete="false">
                    </div>
                  </div>
                  <!--Address-->
                  <div class="bmd-form-group pb-3">
                    <div class="input-group">
                      <div class="input-group-prepend">
                      </div>
                      <input type="text" class="form-control"
                             placeholder="Address"
                             formControlName="address"
                             id="Address" required
                             autocomplete="false">
                    </div>
                  </div>
                  <!--localGovernmentArea-->
                  <div class="bmd-form-group pb-3">
                    <ng-select formControlName="localGovernmentArea"
                               [items]="Locations" class="ng-select-form"
                               id="LocalGovernmentArea" #LocalGovernmentArea
                               [searchable]="false"
                               [notFoundText]="'No Matching Location'"
                               placeholder="Select Local Government Area"
                               bindLabel="schoolName"
                               bindValue="schoolName">
                      <ng-template ng-header-tmp>
                        <input style="width: 100%; line-height: 24px" type="text" placeholder="Search LGA..."
                               (input)="LocalGovernmentArea.filter($event.target.value)"/>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>

                <div *ngIf="step == 2" formGroupName="Form2Details" class="card-body">
                  <!--phoneNo-->
                  <!--<div class="bmd-form-group pb-3">
                    <div class="input-group">
                      <div class="input-group-prepend">
                      </div>
                      <select class="form-control custom-select"
                              formControlName="Location" id="Location">
                        <option value="null">Select Location</option>
                        <option *ngFor="let Location of Locations">
                          {{Location.address.street}} {{Location.address.city}}
                        </option>
                      </select>
                      &lt;!&ndash;<span class="text-danger errorMSG"
                            *ngIf="submitted && Form2Details.Location.errors?.required">
                        Please Select Location
                      </span>&ndash;&gt;
                    </div>
                    <div class="fa-div">
                      <i class="fa fa-sort fa-1x" aria-hidden="true"></i>
                    </div>
                  </div>-->
                  <div class="bmd-form-group pb-3">
                    <div class="input-group">
                      <div class="input-group-prepend">
                      </div>
                      <input type="text" class="form-control"
                             placeholder="Phone Number"
                             formControlName="phoneNo"
                             id="PhoneNo" required
                             autocomplete="false">
                      <!--<span class="text-danger errorMSG"
                            *ngIf="submitted && Form1Details.Address.errors?.required">
                        Please Enter Address
                      </span>-->
                    </div>
                  </div>

                  <!--Email Address-->
                  <div class="bmd-form-group pb-3">
                    <div class="input-group">
                      <div class="input-group-prepend">
                      </div>
                      <input type="text" class="form-control"
                             placeholder="Email Address"
                             formControlName="email"
                             id="Email" required
                             autocomplete="false">
                      <!--<span class="text-danger"
                            *ngIf="submitted && Form3Details.EmailAddress.errors?.required">
                        Please Enter Email Address
                      </span>-->
                    </div>
                  </div>

                  <!--Password-->
                  <div class="bmd-form-group pb-3">
                    <div class="input-group">
                      <div class="input-group-prepend">

                      </div>
                      <input [type]="fieldTextType ? 'text' : 'password'" class="form-control" maxlength="6"
                             placeholder="Password"
                             formControlName="password"
                             id="Password" required
                             autocomplete="false">
                      <div class="input-group-append">
                        <i class="fa input-group-text"
                           [ngClass]="{
                              'fa-eye-slash': !fieldTextType,
                              'fa-eye': fieldTextType
                            }"
                           (click)="toggleFieldTextType()"
                           style="
                            border-bottom: 1px solid #ccc;
                            height: 44px;">
                        </i>
                      </div>

                      <!--<span class="text-danger"
                            *ngIf="submitted && Form2Details.password.errors?.required">
                        Please Enter Password
                      </span>-->
                    </div>
                    <h3 class="PasswordStatus">
                      {{ signup.get("Form2Details.password").status }}
                    </h3>
                  </div>
                </div>

                <div *ngIf="step == 3" formGroupName="Form3Details" class="card-body">
                  <!--Website Url-->
                  <div class="bmd-form-group pb-3">
                    <div class="input-group">
                      <div class="input-group-prepend">
                      </div>
                      <input type="text" class="form-control"
                             placeholder="Website Url"
                             formControlName="websiteUrl"
                             id="WebsiteUrl" required
                             autocomplete="false">
                      <!--<span class="text-danger"
                            *ngIf="submitted && Form3Details.websiteUrl.errors?.required">
                        Please Enter WebsiteUrl
                      </span>-->
                    </div>
                  </div>

                  <!--State Id-->
                  <div class="bmd-form-group pb-3">
                    <div class="input-group">
                      <div class="input-group-prepend">
                      </div>
                      <input oninput="this.value=this.value.slice(0,this.maxLength)"
                             type="number"
                             maxlength="2" class="form-control"
                             placeholder="State Id"
                             formControlName="stateId"
                             id="StateId" required
                             autocomplete="false">
                      <!--<span class="text-danger"
                            *ngIf="submitted && Form3Details.websiteUrl.errors?.required">
                        Please Enter WebsiteUrl
                      </span>-->
                    </div>
                  </div>

                  <!--Website Url-->
                  <div class="bmd-form-group pb-3">
                    <div class="input-group">
                      <div class="input-group-prepend">
                      </div>
                      <input type="text" class="form-control"
                             placeholder="School Session"
                             formControlName="Session"
                             id="Session" required
                             autocomplete="false">
                      <!--<span class="text-danger"
                            *ngIf="submitted && Form3Details.websiteUrl.errors?.required">
                        Please Enter WebsiteUrl
                      </span>-->
                    </div>
                  </div>

                  <!--School Term-->
                  <div class="bmd-form-group pb-3">
                    <div class="input-group">
                      <div class="input-group-prepend">
                      </div>
                      <input oninput="this.value=this.value.slice(0,this.maxLength)"
                             type="number" class="form-control"
                             placeholder="School Term"
                             formControlName="term"
                             maxlength="1"
                             id="Term" required
                             autocomplete="false">
                      <!--<span class="text-danger"
                            *ngIf="submitted && Form3Details.term.errors?.required">
                        Please Enter Term
                      </span>-->
                    </div>
                  </div>
                  <!--KycDocument-->
                  <!--<div class="bmd-form-group pb-3">
                    <div class="input-group">
                      <div class="input-group-prepend">
                      </div>
                      <input type="file" class="form-control doc-upload"
                             placeholder="Kyc Document"
                             formControlName="KycDocument"
                             id="KycDocument"
                             (change)="onFileChange($event)" required>
                      &lt;!&ndash;<span class="text-danger"
                            *ngIf="submitted && Form3Details.KycDocument.errors?.required">
                        Please Upload Kyc Document
                      </span>&ndash;&gt;
                      <div *ngIf="fileUploadProgress" class="fa-div1">
                        Upload progress: {{ fileUploadProgress }}
                      </div>
                    </div>
                  </div>-->
                </div>

                <div class="card-footer justify-content-center">
                  <button type="button" class="next-button mt-2"
                          *ngIf="step == 1" (click)="changeFormStep('next')">
                    <!--<button type="submit" class="btn btn-warning btn-lg" [disabled]="password.errors || email.errors || loading">-->
                    <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>
                    Next
                  </button>
                  <button type="button" class="next-button mt-2"
                          *ngIf="step == 2" (click)="changeFormStep('next')">
                    <!--<button type="submit" class="btn btn-warning btn-lg" [disabled]="password.errors || email.errors || loading">-->
                    <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>
                    Next
                  </button>
                  <button type="submit" class="login-button mt-2"
                          *ngIf="step == 3">
                    <!--<button type="submit" class="btn btn-warning btn-lg" [disabled]="password.errors || email.errors || loading">-->
                    <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>
                    Submit
                  </button>
                </div>

                <!--<div class="text-center" style="font-size: 13px;">
                  <p class="text-center px-2" style="padding: 10px 15px; border-radius: 8px; border: 1px solid #ff9800;
                  box-shadow:
                   0 2px 2px 0 rgb(255 152 0 / 14%), 0 3px 1px -2px rgb(255 152 0 / 20%), 0 1px 5px 0 rgb(255 152 0 / 12%); margin:
                  12px 61% 6px 5px;">
                    <a href="javascript:void(0)" [routerLink]="['/forgot-password']" class="text-rose">
                      Forgot Password?
                    </a>
                  </p>
                </div>-->
                <div  style="font-size: 13px;">
                  <p class="text-center px-2">
                    <a href="javascript:void(0)" [routerLink]="['/forgot-password']"
                       class="text-rose">
                      Forgot Password?
                    </a>
                  </p>
                </div>
                <div  style="font-size: 13px;">
                  <p class="text-center mx-6 mt-3">
                    Don’t have an account yet?
                    <a href="javascript:void(0)" [routerLink]="['/forgot-password']"
                       class="text-rose">
                      Sign up
                    </a>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <app-l-footer></app-l-footer>
      </footer>
    </div>
  </div>
  <!--

  <div class="page-header clear-filter" filter-color="orange">
      <div class="page-header-image" style="background-image:url(../../../assets/img/login.jpg)"></div>
      <div class="content">
        <div class="container">
          <div class="col-md-4 ml-auto mr-auto">
            <div class="card card-login card-plain">
              <form novalidate  #loginForm="ngForm" (ngSubmit)="loginProcess()">
                <div class="card-header text-center">
                  <div class="logo-container">
                    <img src="../../../assets/images/MwareCollegeDreamsWeb.png" alt="Mware College Dreams Web LOGO"
                         width="300px">
                  </div>
                </div>
                <div class="card-body">
                  <div class="input-group no-border input-lg">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="now-ui-icons users_circle-08"></i>
                        </span>
                    </div>
                    <input type="email" class="form-control" placeholder="Email"
                           #email="ngModel" minlength="4" id="email"
                           [(ngModel)]="credentials.email" [ngModelOptions]="{standalone: true}" required>
                  </div>
                  <div class="input-group no-border input-lg">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="now-ui-icons ui-1_lock-circle-open"></i>
                        </span>
                    </div>
                    <input type="password" class="form-control " placeholder="Password" #password="ngModel" minlength="8" id="password"
                           [(ngModel)]="credentials.password" [ngModelOptions]="{standalone: true}" required>
                  </div>
                </div>
                <div class="card-footer text-center">
                  <a type="submit"  class="btn btn-primary btn-round btn-lg btn-block" [disabled]="password.errors ||
                  email.errors || loading">
                    <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>LOGIN TO ACCOUNT
                  </a>
                  <div class="pull-left">
                    <h6>
                      <a [routerLink]="['/forgot-password']" class="link">
                        Forgot Password
                      </a>
                    </h6>
                  </div>
                  <div class="pull-right">
                    <h6>
                      <a [routerLink]="['/']" class="link">Need Help?</a>
                    </h6>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

  -->
</div>
